import { ImportMediaService } from "../../../sales/edit/add-item/import-media.service";
import { HttpStatusCode } from "../../../thor.enums";

export class ImportOnlineMediaService extends ImportMediaService {
    public static $inject: string[] = [
        "$log",
        "$q",
        "$rootScope",
        "$translate",
        "itemService",
        "imageService",
        "uploadService"
    ];

    constructor(
        $log: ng.ILogService,
        $q: ng.IQService,
        $rootScope: ng.IRootScopeService,
        $translate: ng.translate.ITranslateService,
        itemService,
        imageService,
        uploadService
    ) {
        super($log, $q, $rootScope, $translate, itemService, imageService, uploadService);
    }

    protected handleErrors(file, error) {
        if (error.errorMessage) {
            this.notify("incrementGauge", { gauge: "medias", counter: "error" });
            this.summary.errors.push({
                message: error.errorMessage
            });
            return this.$q.reject();
        }
        const errorMessage =
            error.status === HttpStatusCode.PayloadTooLarge
                ? this.$t("fichier_n_a_pas_pu_etre_importe_la_taille_du_fichier_ne_doit_pas_exceder_n_mo", {
                      FILE: file.name,
                      N: "10"
                  })
                : this.$t("erreur_lors_de_la_creation_du_lot", { REFERENCE: file.name });

        this.notify("incrementGauge", { gauge: "medias", counter: "error" });
        this.summary.errors.push({
            message: errorMessage
        });
        // only a warning, keep process
        return this.$q.resolve();
    }

    protected createItem() {
        const body = {
            category_id: this.sale.resource.category_id,
            pricing: {
                reserve_price: null,
                starting_price: 0,
                caution: null
            }
        };

        return this.sale.createItem(body)
            .then(item => {
                return this.$q.resolve(item);
            })
            .catch(error => {
                this.$log.error("Error while creating item", error);
                return this.$q.reject(error);
            });
    }
}
